import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '../states/auth-state.service';

/** Solo profesores entran al área de profesor. */
export const teacherGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['login']);
    return false;
  }
  if (!auth.isTeacher()) {
    router.navigateByUrl(auth.landingRoute());
    return false;
  }
  return true;
};
